import { themeTools } from "native-base";

const accordionSummaryVariants = {
    primary: (props) => ({
        bg: "primary.500",
        color: "inherit",
        _hover: {
            bg: "primary.500",
            color: "inherit",
        },
        _expanded: {
            bg: "primary.600:alpha.60",
            borderBottomColor: undefined,
            color: "inherit",
            _text: {
                color: "inherit"
            },
        },
    })
}

export const AccordionTheme = {
    Accordion: {
        baseStyle: {
            borderRadius: "8",
        },

        variants: {
            bg: "primary.500",
            color: "inherit",
        },
    },
    AccordionSummary: {
        baseStyle: (props) => ({
            color: "gray.500",
            cursor: "pointer",
            _hover: {
                bg: themeTools.mode('coolGray.100', 'dark.50')(props),
            },
            _expanded: {
                bg: 'primary.500',
                borderBottomColor: undefined,
                color: "lightText",
                _text: { color: "lightText" },
            },
            _disabled: {
                bg: themeTools.mode('gray.200', 'gray.700')(props),
                _text: { color: themeTools.mode('darkText', "lightText")(props) },
            },
        }),
        variants: accordionSummaryVariants
    },
    AccordionDetails: {
        variants: {
            primary: (props) => ({
                bg: "primary.600:alpha.60",
                color: "inherit",
            })
        }
    },
    AccordionIcon: {
        variants: {
            primary: (props) => {
                return {
                    color: "inherit",
                }
            }
        }
    }
}